<adapt-dialog [maxWidth]="540"
              [fitHeight]="true">
    <h3 adapt-dialog-title>{{ dialogData.isCopying ? "Copy" : "Move" }} meeting template</h3>
    <div adapt-dialog-content
         class="h-100 d-flex flex-column">
        <div class="alert alert-info">
            Select where to {{ dialogData.isCopying ? "copy" : "move" }} the meeting template <b>[{{ template.name }}]</b>
        </div>
        <adapt-select-teams [filter]="filter"
                            [singleSelection]="true"
                            (teamsSelectedChange)="moveDestinations = $event"></adapt-select-teams>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveBlockingClick]="processMoveOrCopy"
                                   (cancelClick)="cancel()"
                                   [saveIsDisabled]="!haveMoveDestinations"></adapt-standard-dialog-buttons>
</adapt-dialog>
